module.exports = __webpack_public_path__ + "img/logo1 (26).31b5da32.jpg";